import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { autocomplete, getAlgoliaResults } from "@algolia/autocomplete-js";
import { createAutocomplete } from "@algolia/autocomplete-core";
import { ConvertToFloat, isValidArray } from "../../Layout/Common/common";
import { Link, useNavigate } from "react-router-dom";
import { ItemContainer } from "./itemContainer";
import "react-loading-skeleton/dist/skeleton.css";
import { AutosuggestPopupItemSkeleton } from "../../Skeleton/autoSuggestPopup/autosuggestPopupItemSkeleton";

import { CategorySuggestion } from "./categorySuggestion";
import { QuerySuggestion } from "./querySuggestion";
import { PAGES } from "../../routeConfig";
import { AutoCompleteResult } from "./autoCompleteResult";
import debounce from "lodash/debounce";
import { searchIndex } from "../../Layout/Common/algoliaInstantLib";
import algoliasearch from "algoliasearch";

const searchClient = algoliasearch(
  `${process.env.REACT_APP_ALGOLIA_APP_ID}`,
  `${process.env.REACT_APP_ALGOLIA_SEARCH_KEY}`,
);

const indexName = `${process.env.REACT_APP_ALGOLIA_INDEX_NAME}`;
const newproductindexName = `${process.env.REACT_APP_ALGOLIA_NEWPRODUCT_INDEX_NAME}`;
const suggestionIndexName = `${process.env.REACT_APP_ALGOLIA_SUGGESTION_INDEX}`;

export const AutoCompleteSearchBox = ({ isOpen }) => {
  const acRef = useRef(null);
  const [srcText, setSrcText] = useState("");
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [hits, setHits] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, [isOpen]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const searchStr = params.get("q");
    setQuery(searchStr ?? "");
  }, [window.location.search]);

  useEffect(() => {
    if (query) {
      fetchResults();
    } else {
      fetchNewResults();
    }
  }, [query]);
  const fetchResults = async () => {
    const result = await Promise.all([
      searchIndex(indexName, { query, hitsPerPage: 20, facets: ["category"] }),
      searchIndex(suggestionIndexName, { query, hitsPerPage: 20 }),
    ]);
    const [mainRes, suggestionRes] = result;
    let cateList = mainRes.facets?.category ?? null;
    setHits(mainRes.hits);
    let arrayCateFilter = [];
    if (cateList) {
      const sortedCategories = Object.entries(cateList)
        .sort((a, b) => b[1] - a[1])
        .flatMap(([name, count]) => name);
      arrayCateFilter = [...new Set(sortedCategories)];
    }

    if (isValidArray(suggestionRes.hits)) {
      setSuggestions(
        suggestionRes.hits.map((hit) => ({
          value: hit._highlightResult.query.value,
          query: hit.query,
          categories: arrayCateFilter.slice(0, 6),
        })),
      );
    } else {
      setSuggestions([
        {
          value: "<b>" + suggestionRes.query + "</b>",
          query: suggestionRes.query,
          categories: arrayCateFilter.slice(0, 6),
        },
      ]);
    }
  };

  const fetchNewResults = async () => {
    const result = await Promise.all([
      searchIndex(newproductindexName, {
        query,
        hitsPerPage: 100,
        facets: ["category"],
        facetFilters: ["categories.lvl0:New Products"],
      }),
      searchIndex(suggestionIndexName, { query, hitsPerPage: 20 }),
    ]);
    const [mainRes, suggestionRes] = result;
    let cateList = mainRes.facets?.category ?? null;
    setHits(mainRes.hits);
    let arrayCateFilter = [];
    if (cateList) {
      const sortedCategories = Object.entries(cateList)
        .sort((a, b) => b[1] - a[1])
        .flatMap(([name, count]) => name);
      arrayCateFilter = [...new Set(sortedCategories)];
    }

    if (isValidArray(suggestionRes.hits)) {
      setSuggestions(
        suggestionRes.hits.map((hit) => ({
          value: hit._highlightResult.query.value,
          query: hit.query,
          categories: arrayCateFilter.slice(0, 6),
        })),
      );
    } else {
      setSuggestions([
        {
          value: "<b>" + suggestionRes.query + "</b>",
          query: suggestionRes.query,
          categories: arrayCateFilter.slice(0, 6),
        },
      ]);
    }
  };

  const debouncedSearch = useCallback(
    debounce((val) => {
      setQuery(val);
    }, 500),
    [],
  );
  const handleChange = (e) => {
    setSrcText(e.target.value);
    debouncedSearch(String(e.target.value).trim());
  };

  return (
    <Fragment>
      {/* <div className="row d-none d-lg-block" style={{ display: "none" }}>
        <div className="col-lg-8 offset-lg-2">
          <div className="search-input">
            <div className="close-search" onClick={handleHide}>
              <i
                id="close-search"
                className="fa-regular fa-circle-xmark d-none d-lg-block"
              ></i>
            </div>
            <form>
              <div className="suggestion-input button-effect">
                <input
                  ref={inputRef}
                  id="search-box"
                  type="text"
                  value={srcText ?? ""}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Search Here..."
                  autoComplete="off"
                />
                <button
                  type="submit"
                  className="btn btn-products btn-search d-none d-lg-block"
                  onClick={(e) => {
                    e.preventDefault();
                    if (srcText)
                      navigate(
                        PAGES.SEARCH + "?q=" + encodeURIComponent(srcText)
                      );
                    handleHide();
                  }}
                >
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
      </div> */}
      <AutoCompleteResult hits={hits} query={query} suggestions={suggestions} />
    </Fragment>
  );
};
